import { useState, useCallback, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import ColorPicker from "react-pick-color";


const ColorPickerModal = ({ open, setOpen, setColorMain }: any) => {
    const [color, setColor] = useState("#fff");
    
    // Reset color when modal opens
    useEffect(() => {
        if (open) {
            setColor("#fff");
        }
    }, [open]);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, [setOpen]);

    const submit = useCallback(() => {
        setColorMain(color);
        handleClose();
    }, [color, setColorMain, handleClose]);

    const changeText = useCallback((e: string) => {
        setColor(e);
    }, []);

    const handleColorChange = useCallback((colorObj: any) => {
        changeText(colorObj.hex);
    }, [changeText]);

    return (
        <Modal show={open} onHide={handleClose} className="profile-modal">
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <ColorPicker color={color} className="builder-color-picker" onChange={handleColorChange} />
                <Button onClick={submit}>Submit</Button>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    )
}

export default ColorPickerModal;